import listeningCards from '@/store/modules/cards/library/listening';
import sacCards from '@/store/modules/cards/library/sac';
import blipCards from '@/store/modules/cards/library/blip';
import sacListeningCards from '@/store/modules/cards/library/sac-listening';
import changeLogs from '@/store/modules/cards/library/changes';

export default {
  changeLogs,
  allowCards: [
    ...listeningCards,
    ...sacCards,
    ...blipCards,
    ...sacListeningCards,
  ],
  dataFetched: {},
};
